const BANNED_MARKDOWN_HEADING_CHARS_REGEX = /['(),./:;?[\]{}]/g;
function toMarkdownHeadingHrefHash(name: string): string {
  return name
    .toLowerCase()
    .replaceAll(' ', '-')
    .replaceAll(BANNED_MARKDOWN_HEADING_CHARS_REGEX, '');
}

export { toMarkdownHeadingHrefHash };
